import { useEffect, useMemo, useRef, useState } from 'react';
import { IconButton } from '../../../layout/form';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, registerRoutes } from '../../../func';
import ContactModal from './contactModal';
import { useDispatch } from 'react-redux';
import Axios from 'axios';

const ContactsTab = ({ contacts, pharmacyId, refresh }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );
  const ref = useRef(null);

  const [selectedContact, setSelectedContact] = useState(null);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const autoAdjustHeights = () => {
    const cards = ref.current.querySelectorAll('div.card.contact-card');

    cards.forEach(card => {
      const labelElements = card.querySelectorAll('table.t-labels>tbody>tr');
      const valueElements = card.querySelectorAll('table.t-values>tbody>tr');

      labelElements.forEach((labelElement, index) => {
        valueElements[index].style.height = `${labelElement.clientHeight}px`;
      });
    });
  };

  useEffect(() => {
    autoAdjustHeights();
    window.addEventListener('resize', autoAdjustHeights);
    return () => {
      window.removeEventListener('resize', autoAdjustHeights);
    };
  }, [contacts]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          deleteContact: {
            func: pharmacyContactId => {
              if (!window.confirm('Are you sure you want to delete this user?'))
                return;

              Axios.delete('/api/v2/pharmacycontact/delete/one', {
                data: { ...authData, pharmacyContactId },
              })
                .then(({ data }) => {
                  refresh();
                  dispatch(data);
                })
                .catch(logOut);
            },
            type: 'd',
          },
        },
        path
      ),
    [path, dispatch, refresh, authData]
  );

  return (
    <div ref={ref} style={{ padding: '1vw' }}>
      <div className="row">
        <IconButton
          icon="add"
          onClick={() => {
            setSelectedContact(null);
            setIsContactModalOpen(true);
          }}
        />
      </div>
      <div className="row">
        {contacts
          ?.sort((a, b) => a.id - b.id)
          .map(contact => {
            const {
              id,
              customerAuthId,
              firstName,
              lastName,
              title,
              phone,
              emailAddress,
              department,
            } = contact;

            return (
              <div key={id} className="card contact-card">
                <div className="card-content">
                  <div
                    className="row"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <IconButton
                      icon="delete"
                      onClick={() => networkCalls.deleteContact(id)}
                    />
                    <IconButton
                      icon="edit"
                      onClick={() => {
                        setSelectedContact(contact);
                        setIsContactModalOpen(true);
                      }}
                    />
                  </div>
                  <div className="row">
                    <div className="col s4 m3 l2">
                      <table className="t-labels">
                        <tbody>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              ID
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              First Name
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Last Name
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Title
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Email Address
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Phone #
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Department
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Has Portal Login
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col s8 m9 l10">
                      <table className="t-values">
                        <tbody>
                          <tr>
                            <td style={{ padding: '4px' }}>{id}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{firstName}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{lastName || ''}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{title || ''}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {emailAddress || ''}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{phone || ''}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {department || ''}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {customerAuthId ? 'Yes' : 'No'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <ContactModal
        isOpen={isContactModalOpen}
        setIsOpen={setIsContactModalOpen}
        contact={selectedContact}
        pharmacyId={pharmacyId}
        refresh={refresh}
      />
    </div>
  );
};

export default ContactsTab;
